module.exports = __webpack_public_path__ + "img/bg_7@2x.b3c820e4.png";